import React from "react";
import { Modal, Button } from "react-bootstrap";

const ComplianceDetailModal = ({ show, onHide, compliance }) => {
  if (!compliance) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Compliance Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>User Name:</strong> {compliance.id_user?.name || "N/A"}
        </p>
        <p>
          <strong>License Number:</strong> {compliance.license_number}
        </p>
        <p>
          <strong>Pan Number:</strong> {compliance.panCard_number}
        </p>
        <p>
          <strong>Voter Number:</strong> {compliance.voter_number}
        </p>
        <p>
          <strong>Aadhar Card Number:</strong> {compliance.aadhar_number}
        </p>
        <p>
          <strong>IDFY Verified:</strong> {compliance.idfyVerified}
        </p>
        <p>
          <strong>Client Name:</strong>{" "}
          {Array.isArray(compliance.id_client) &&
          compliance.id_client.length > 0 ? (
            compliance.id_client.map((client, index) => (
              <div key={client._id}>
                <span>
                  Client {index + 1} - {client.name}
                </span>
              </div>
            ))
          ) : (
            <span>N/A</span>
          )}
        </p>
        <p>
          <strong>Verification Done:</strong>{" "}
          {compliance.idfyVerified ? "Yes" : "No"}
        </p>
        <p>
          <strong>Status:</strong> {compliance.status}
        </p>
        <p>
          <strong>Offer Letter:</strong>{" "}
          {compliance.offer_letter ? "Yes" : "No"}
        </p>
        <p>
          <strong>Induction:</strong> {compliance.induction ? "Yes" : "No"}
        </p>
        <p>
          <strong>Is Consent:</strong> {compliance.isConsent ? "Yes" : "No"}
        </p>
        <p>
          <strong>LM:</strong> {compliance.LM ? "Yes" : "No"}
        </p>
        <p>
          <strong>Created At :</strong> {formatDate(compliance.createdAt)}
        </p>
        <p>
          <strong>Updated At:</strong> {formatDate(compliance.updatedAt)}
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {/* Aadhar Front */}
          {compliance.aadharCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Aadhar Card Front:</strong>
              </p>
              <img
                src={compliance.aadharCard.front.url}
                alt="Aadhar Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.aadharCard.front.url}
                download="AadharCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Aadhar Back */}
          {compliance.aadharCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Aadhar Card Back:</strong>
              </p>
              <img
                src={compliance.aadharCard.back.url}
                alt="Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.aadharCard.back.url}
                download="AadharCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Driving License */}
          {compliance.drivingLicense?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Driving License Front:</strong>
              </p>
              <img
                src={compliance.drivingLicense.front.url}
                alt="Driving License Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.drivingLicense.front.url}
                download="DrivingLicense_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Driving License */}
          {compliance.drivingLicense?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Driving License Back:</strong>
              </p>
              <img
                src={compliance.drivingLicense.back.url}
                alt="Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.drivingLicense.back.url}
                download="DrivingLicense_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Voter Card Front */}
          {compliance.voterCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Voter Card Front:</strong>
              </p>
              <img
                src={compliance.voterCard.front.url}
                alt="Voter Card Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.voterCard.front.url}
                download="VoterCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Voter Card Back */}
          {compliance.voterCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Voter Card Back:</strong>
              </p>
              <img
                src={compliance.voterCard.back.url}
                alt="Voter Card Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.voterCard.back.url}
                download="VoterCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Parent Aadhar Front */}
          {compliance.parentAadharCard?.front?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Parent Aadhar Front:</strong>
              </p>
              <img
                src={compliance.parentAadharCard.front.url}
                alt="Parent Aadhar Front"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.parentAadharCard.front.url}
                download="ParentAadharCard_Front.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Parent Aadhar Back */}
          {compliance.parentAadharCard?.back?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Parent Aadhar Back:</strong>
              </p>
              <img
                src={compliance.parentAadharCard.back.url}
                alt="Parent Aadhar Back"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.parentAadharCard.back.url}
                download="AadharCard_Back.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Pan Card */}
          {compliance.panCard?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Pan Card :</strong>
              </p>
              <img
                src={compliance.panCard.url}
                alt="Pan Card"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.panCard.url}
                download="PanCard.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
          {/* Consent Document */}
          {compliance.consent_document?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Consent Document:</strong>
              </p>
              <img
                src={compliance.consent_document.url}
                alt="Consent Document"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.consent_document.url}
                download="Consent_Document.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {/* Police Verification */}
          {compliance.police_verification?.url && (
            <div style={{ maxWidth: "45%" }}>
              <p>
                <strong>Police Verification:</strong>
              </p>
              <img
                src={compliance.police_verification.url}
                alt="Police Verification"
                style={{ width: "100%", height: "auto" }}
              />
              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={compliance.police_verification.url}
                download="Police_Verification.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ComplianceDetailModal;
